// Owner: collab-kit (wave 1), library (wave 2). The comment command of plan §4.2 (⌘⌥M on the selection
// or at the caret): editors add it to their own scope, so it fires only where it makes sense.
import { type Scope, defineCommand } from '@dataroom/interaction';
import { t } from '../lib/i18n';

export const COMMENT_SHORTCUT = 'mod+alt+m';

/** `⌘⌥M` → `ctx.comment()` in an editor scope (return false when nothing can be commented). */
export function commentCommand<Ctx extends { comment: () => boolean | void }>(
  scope: Scope<Ctx>,
  id = `${scope.id}.comment`,
) {
  return defineCommand<Ctx>({
    id,
    title: () => t('collab.comments.command'),
    icon: 'comment',
    shortcut: COMMENT_SHORTCUT,
    scope,
    textSafe: true,
    run: (ctx) => ctx.comment(),
  });
}
